import React from 'react';
import PropTypes from 'prop-types';
import { getStyles, addModifierClasses, addToArray } from '../../../shared/utility';

import localStyles from './Icon.scss';
const styles = getStyles(localStyles);

const icon = (props) => {

    if (!props.icon && !props.customIcon) {
        return null;
    }

    let iconClasses = ['icon'];
    iconClasses = addModifierClasses(props.modifiers, 'icon', iconClasses);
    iconClasses = addToArray(props.classes, iconClasses);

    const attrs = props.attrs ? props.attrs : null;

    const src = props.customIcon || require(`../../../assets/icons/ic-${props.icon}${props.color ? '-' + props.color : ''}.svg`);

    return (
        <img className={styles(iconClasses)} {...attrs} alt="" src={src} />
    );
};

icon.propTypes = {
    // properties
    attrs: PropTypes.object,
    icon: PropTypes.string,
    customIcon: PropTypes.string,
    classes: PropTypes.string,
    modifiers: PropTypes.arrayOf(PropTypes.string),
    color: PropTypes.string
};

export default icon;



// WEBPACK FOOTER //
// ./src/components/UI/Icon/Icon.js